import { render, staticRenderFns } from "./PanelRefreshTime.vue?vue&type=template&id=6d0b4b3d&scoped=true"
import script from "./PanelRefreshTime.vue?vue&type=script&lang=js"
export * from "./PanelRefreshTime.vue?vue&type=script&lang=js"
import style0 from "./PanelRefreshTime.vue?vue&type=style&index=0&id=6d0b4b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b4b3d",
  null
  
)

export default component.exports